import { tocRiveUrl } from './tocBannerRive';
import { TournamentOfChampionsState, type TournamentOfChampions, type TournamentOfChampionsRound } from './types';

// Core's isRoundLostInCoin: a finalized round the player finished past the cut.
const isRoundLost = (round: TournamentOfChampionsRound) =>
  round.isFinalized &&
  round.playerPosition != null &&
  round.playersToAdvanceLimit != null &&
  round.playerPosition >= round.playersToAdvanceLimit;

// The held data says ACTIVE_ROUND until the next fetch, past the round's end.
const hasLiveRoundEnded = (toc: TournamentOfChampions, now: number) => {
  const endDate = toc.rounds.find((round) => round.roundIndex === toc.currentRoundIndex)?.endDate;
  return !endDate || Date.parse(endDate) <= now;
};

/** A round the player can play now, joined or not, with a lobby file: the lobby banner can come from this ToC. */
export function isLiveTocForLobbyBanner(
  toc: TournamentOfChampions | null,
  now = Date.now(),
): toc is TournamentOfChampions {
  const rives = toc?.assets?.rives;
  return (
    toc?.state === TournamentOfChampionsState.ACTIVE_ROUND &&
    !toc.isEliminated &&
    !toc.rounds.some(isRoundLost) &&
    !hasLiveRoundEnded(toc, now) &&
    !!(tocRiveUrl(rives, 'lobbyBannerDesktop') || tocRiveUrl(rives, 'lobbyBannerMobile'))
  );
}
